module.exports = __webpack_public_path__ + "static/media/picture-12@2x.680db20a.png";